import { FormControl, Select, MenuItem, InputLabel } from '@material-ui/core';
import { SettingsOutlined, WebOutlined } from '@material-ui/icons';
import Skeleton from '@material-ui/lab/Skeleton';

import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import Stepper from '../../../components/common/stepper';
import { ACTION } from '../../../reducer/projectReducer';

import { ProjectContext } from '../projectContext';
import LandingForm from './landing/landingForm';
import PlatformForm from './platform/platformForm';
import QuestionsForm from './questions/questionsForm';
import ConfirmationModal from '../../ClientContainer/statusModal';
import ProjectApi from '../project-api';
import ClientsApi from '../../ClientContainer/client-api';
import { normalizeAvailableRoles } from '../../../utils/registrationRoles';

const ProjectWizard = () => {
  const [state, dispatch] = useContext(ProjectContext);
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const location = useLocation();
  const {
    state: { client, announcement },
  } = location;

  useEffect(() => {
    //get info about announcement
    (async () => {
      try {
        if (client?.id) {
          try {
            const {
              data: { client: fetchedClient },
            } = await ClientsApi.fetchClient(client.id);

            dispatch({
              type: ACTION.UPDATE_CLIENT,
              payload: {
                client: {
                  ...client,
                  ...fetchedClient,
                },
              },
            });
          } catch (_clientError) {
            dispatch({ type: ACTION.UPDATE_CLIENT, payload: { client } });
          }
        }
        if (!announcement) {
          setIsLoading(false);
          return;
        }

        const {
          data,
        } = await ProjectApi.fetchProjectAnnouncement(
          announcement.id
        );

        const { status, id, configuration, ...rest } = data.announcement;
        setAnnouncementStatus(status);

        dispatch({
          type: ACTION.UPDATE_ANNOUNCEMENT_STATUS,
          payload: {
            status,
            id,
          },
        });

        dispatch({
          type: ACTION.UPDATE_LANDING,
          payload: {
            landing: rest,
          },
        });

        dispatch({
          type: ACTION.UPDATE_CONFIGURATION,
          payload: {
            configuration: {
              ...(configuration || {}),
              registration: {
                ...(configuration?.registration || {}),
                availableRoles: normalizeAvailableRoles(
                  configuration?.registration?.availableRoles
                ),
              },
            },
          },
        });

        dispatch({
          type: ACTION.UPDATE_PLATFORM,
          payload: {
            platform: {
              ...state.platform,
              ...(configuration?.platform || {}),
            },
          },
        });

        dispatch({
          type: ACTION.UPDATE_LOGIN,
          payload: {
            login: {
              ...state.login,
              ...(configuration?.login || {}),
            },
          },
        });

        setIsLoading(false);
      } catch (error) {}
    })();
  }, []);

  const [announcementStatus, setAnnouncementStatus] = useState('');

  const [activeStep, setActiveStep] = useState(0);

  const onChangeStep = (step) => {
    if (step >= 0 && step < steps().length) {
      setActiveStep(step);
    }
  };

  const onClose = () => setIsOpen(false);
  const onAccept = () => {
    dispatch({
      type: ACTION.UPDATE_ANNOUNCEMENT_STATUS,
      payload: { status: !announcementStatus },
    });
    setAnnouncementStatus((prev) => !prev);
    onClose();
  };

  const onChangeStatus = (status) => {
    setAnnouncementStatus(status);
    dispatch({
      type: ACTION.UPDATE_ANNOUNCEMENT_STATUS,
      payload: {
        status,
        id: announcement?.id || null,
      },
    });
  }

  const steps = () => {
    return [
      { title: 'Landing de registro', Componente: LandingForm },
      { title: 'Plataforma customizada', Componente: PlatformForm },
      { title: 'Preguntas Convocatoria', Componente: QuestionsForm },
    ];
  };

  //if client status is non active  toggle should be disabled for announcements
  const isToggleDisabled = !client.status;
  const announcementTitle = announcement
    ? 'Editar convocatoria para cliente'
    : 'Crear convocatoria para cliente';
  const statusLabel = {
    'user-register': 'Registro',
    active: 'Activada',
    waiting: 'Desactivada',
  }[announcementStatus] || 'Sin estado';

  return (
    <>
      {isLoading ? (
        <div className="client-container announcement-wizard announcement-wizard--loading">
          <Skeleton variant="rect" height={140} />
          <div className="announcement-wizard__loading-content">
            <Skeleton variant="rect" height={430} />
            <Skeleton variant="rect" height={760} />
          </div>
        </div>
      ) : (
        <div className="client-container">
          <ConfirmationModal
            header={
              !announcementStatus
                ? 'Activar Convocatoria'
                : 'Desactivar Convocatoria'
            }
            title={
              !announcementStatus
                ? '¿Estás seguro/a que deseas activar la convocatoria?'
                : '¿Estás seguro/a que deseas dejar la convocatoria en espera?'
            }
            open={isOpen}
            onClose={onClose}
            handleAccept={onAccept}
            handleDenied={onClose}
          />
          <div className="wizard announcement-wizard">
            <header className="announcement-wizard__hero">
              <div className="announcement-wizard__hero-icon">
                <WebOutlined />
              </div>
              <div className="announcement-wizard__hero-copy">
                <span className="announcement-wizard__eyebrow">
                  Gestión de convocatorias
                </span>
                <h1>{announcementTitle}</h1>
                <p>
                  Configura el acceso, el contenido y la apariencia de la
                  experiencia asociada a este cliente.
                </p>
              </div>
              <span
                className={`announcement-wizard__status-chip announcement-wizard__status-chip--${
                  announcementStatus || 'unset'
                }`}
              >
                {statusLabel}
              </span>
            </header>
            <div className="wizard__content">
              <div className="wizard__steps-container wizard-padding">
                <div className="announcement-wizard__sidebar-heading">
                  <span className="announcement-wizard__sidebar-icon">
                    <SettingsOutlined />
                  </span>
                  <div>
                    <span className="announcement-wizard__eyebrow">
                      Configuración
                    </span>
                    <strong>Estado y etapas</strong>
                  </div>
                </div>
                <div className="announcement-wizard__status-field">
                  <FormControl fullWidth>
                    <InputLabel id="announcement-status-label">
                      Estado de la convocatoria
                    </InputLabel>
                    <Select
                      labelId="announcement-status-label"
                      value={announcementStatus}
                      onChange={(e) => onChangeStatus(e.target.value)}
                      disabled={isToggleDisabled}
                    >
                      <MenuItem value="user-register">Registro</MenuItem>
                      <MenuItem value="active">Activada</MenuItem>
                      <MenuItem value="waiting">Desactivada</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                <div className="announcement-wizard__steps-label">Etapas</div>
                {steps(client.isCustomized).map((step, index) => (
                  <Stepper
                    text={step.title}
                    stepNumber={index + 1}
                    isActive={index === activeStep}
                    key={`step-${index}`}
                    isDone={index < activeStep}
                  />
                ))}
              </div>
              <div className="wizard__form-container">
                {steps(client.isCustomized).map((step, index) => {
                  const C = step.Componente;
                  return (
                    index === activeStep && (
                      <C
                        key={`showing-step-${index}`}
                        onPrev={() => onChangeStep(index - 1)}
                        onNext={() => onChangeStep(index + 1)}
                      />
                    )
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProjectWizard;
